import React from "react";
import "./Hero.css";

export const Hero = () => {
  return (
    <section className="section">
      <div className="heroText">
        <p className="pTag">Hello, My Name is</p>
        <h1 className="heroh1Tag">Piyush Kesarwani</h1>
        <h1 className="heroh1Tag">I build things for the web.</h1>
        <p className="pTag" style={{ width: "500px" }}>
          I'm a frontend Web developer and a Technical Blog Writer expecializing
          in building and creating exceptional digital products/projects for the
          web. I am a content Creator & I love designing websites and mobile
          apps.
        </p>
        <div className="d-flex flex-row align-items-center">
          <a target="_blank" rel="noreferrer" href="https://github.com/piyushkesarwani">
            <button className="btn me-4">GitHub Profile</button>
          </a>
          <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/piyush-kesarwani-809a30219/">
            <button className="btn">LinkedIn Profile</button>
          </a>
        </div>
      </div>
    </section>
  );
};
